import script from "./base.vue?vue&type=script&setup=true&lang=js"
export * from "./base.vue?vue&type=script&setup=true&lang=js"

import "./base.vue?vue&type=style&index=0&id=0b7f16d6&lang=less"

const __exports__ = script;

export default __exports__